import React from "react";
import { ReportPresentationChrome } from "@common/schemas/domains/reportSettings/report-presentation.schema";
import { hasChromeText } from "./localReportChrome";
import { useAmountScaleCaption } from "./useAmountScaleCaption";
import styles from "./AccountingReportHeader.module.scss";

interface AccountingReportHeaderProps {
    chrome: ReportPresentationChrome;
}

export const AccountingReportHeader: React.FC<AccountingReportHeaderProps> = ({
    chrome,
}) => {
    const scaleCaption = useAmountScaleCaption();

    return (
        <header className={styles.header}>
            {hasChromeText(chrome.header) && (
                <p className={styles.headerLine}>{chrome.header}</p>
            )}
            {hasChromeText(chrome.title) && (
                <h3 className="font-weight-medium mb-4">{chrome.title}</h3>
            )}
            {hasChromeText(chrome.subtitle) && (
                <h5 className="font-weight-medium mb-1">{chrome.subtitle}</h5>
            )}
            {hasChromeText(chrome.subtitle2) && (
                <p className="text-grey">{chrome.subtitle2}</p>
            )}
            {scaleCaption && (
                <p className={styles.amountScale}>{scaleCaption}</p>
            )}
        </header>
    );
};
